import { useEffect } from "react";

import { BaseStore } from "@/Common/Stores/BaseStore";

/** Register an effect to be invoked on a store change.
 * (Will  automatically deregister on component dismount.)
 * @param {BaseStore} store - The store that invokes the effect.
 * @param {React.EffectCallback} effect - The effect to be invoked by the store.
 */
function useOnStoreChange(store: BaseStore, effect: React.EffectCallback): void {
    useEffect(
        () => {
            const eventId = store.AddChangeListener(effect, null);
            return () => store.RemoveChangeListener(eventId);
        },
        []
    );
}

export { useOnStoreChange };
